<template>
    <div v-if="loadComponent">
        <v-container>
            <h1>{{ title }}</h1>
            <v-card :class="classPadding">
                <v-row>
                    <v-col cols="12" md="12" sm="12" xs="12" :class="classPadding">
                        <v-alert border="top"
                                 color="red lighten-2"
                                 dark
                                 dismissible
                                 v-model="showError">
                            <v-row v-for="(err, key) in errors" :key="key">
                                <v-col :class="classPadding">
                                    <span>• {{ err }}</span>
                                </v-col>
                            </v-row>
                        </v-alert>
                    </v-col>
                </v-row>
                <v-card-title>
                    <span class="caption">Option to import</span>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" xs="12" sm="12" md="12" class="pa-0 ma-0">
                            <v-checkbox label="Check/Clear All"
                                        :class="classPadding"
                                        v-model="checkAll"></v-checkbox>
                        </v-col>
                        <!-- <template v-for="(n, key) in 4">
                          <v-col cols="12" xs="12" sm="4" md="3" class="pa-0 ma-0" :key="key">
                            <template  v-for="(setup, setupKey) in setupList">
                              <template v-if="(setupList.length/4).toFixed(0) * n >= (setupKey + 1)">
                               <v-checkbox
                                :label="`${(setupKey + 1)} ${setup.name}`"
                                :class="classPadding"
                                v-model="selectedSetup"
                                :value="setup.value"
                                :key="setupKey"
                              ></v-checkbox>
                              </template>
                            </template>
                            <p>{{n}}</p>
                          </v-col>
                        </template> -->
                        <template v-for="(setup, setupKey) in setupList">
                            <v-col cols="12" xs="12" sm="4" md="3" class="pa-0 ma-0" :key="setupKey">
                                <v-checkbox :label="`${(setupKey + 1)} ${setup.name}`"
                                            :class="classPadding"
                                            v-model="selectedSetup"
                                            :value="setup.value"
                                            :key="setupKey"></v-checkbox>
                            </v-col>
                        </template>

                        <!-- <v-col cols="12" xs="12" sm="4" md="3" class="pa-0 ma-0">
                          <v-checkbox
                            label="1. Payroll Location"
                            :class="classPadding"
                            v-model="masterfile"
                          ></v-checkbox>
                          <v-checkbox
                            label="2. Timekeep Group"
                            :class="classPadding"
                            v-model="empInfo"
                          ></v-checkbox>
                          <v-checkbox
                            label="3. Pagibig"
                            :class="classPadding"
                            v-model="basicSal"
                          ></v-checkbox>
                          <v-checkbox
                            label="4. Movement Type Details"
                            :class="classPadding"
                            v-model="allo"
                          ></v-checkbox>
                          <v-checkbox
                            label="5. Earnings"
                            :class="classPadding"
                            v-model="earnings"
                          ></v-checkbox>

                           <v-checkbox
                            label="6. Deductions"
                            :class="classPadding"
                            v-model="physicalExam"
                          ></v-checkbox>
                          <v-checkbox
                            label="7. Area"
                            :class="classPadding"
                            v-model="bankInfo"
                          ></v-checkbox>
                          <v-checkbox
                            label="8. Pay House"
                            :class="classPadding"
                            v-model="eduBack"
                          ></v-checkbox>
                          <v-checkbox
                            label="9. Branch"
                            :class="classPadding"
                            v-model="familyInfo"
                          ></v-checkbox>
                          <v-checkbox
                            label="10. Department"
                            :class="classPadding"
                            v-model="healthRecord"
                          ></v-checkbox>

                           <v-checkbox
                            label="11. Division"
                            :class="classPadding"
                            v-model="license"
                          ></v-checkbox>
                          <v-checkbox
                            label="12. Group"
                            :class="classPadding"
                            v-model="awardsComm"
                          ></v-checkbox>
                          <v-checkbox
                            label="13. Location"
                            :class="classPadding"
                            v-model="discCase"
                          ></v-checkbox>
                          <v-checkbox
                            label="14. Section"
                            :class="classPadding"
                            v-model="medCase"
                          ></v-checkbox>
                          <v-checkbox
                            label="15. Unit"
                            :class="classPadding"
                            v-model="prevEmp"
                          ></v-checkbox>

                          <v-checkbox
                            label="16. Designation"
                            :class="classPadding"
                            v-model="sem"
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="12" xs="12" sm="4" md="3" class="pa-0 ma-0">
                          <v-checkbox
                            label="17. Job Level"
                            :class="classPadding"
                            v-model="semRecomm"
                          ></v-checkbox>
                          <v-checkbox
                            label="18. Emp Status"
                            :class="classPadding"
                            v-model="medical"
                          ></v-checkbox>

                          <v-checkbox
                            label="19. Emp Category"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>

                          <v-checkbox
                            label="20. Emp Classification"
                            :class="classPadding"
                            v-model="sem"
                          ></v-checkbox>
                          <v-checkbox
                            label="21. Designation Duties and Responsibilities"
                            :class="classPadding"
                            v-model="semRecomm"
                          ></v-checkbox>
                          <v-checkbox
                            label="22. Rank"
                            :class="classPadding"
                            v-model="medical"
                          ></v-checkbox>

                          <v-checkbox
                            label="23. Grade"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>

                          <v-checkbox
                            label="24. Step"
                            :class="classPadding"
                            v-model="sem"
                          ></v-checkbox>
                          <v-checkbox
                            label="25. Specialization"
                            :class="classPadding"
                            v-model="semRecomm"
                          ></v-checkbox>
                          <v-checkbox
                            label="26. Province"
                            :class="classPadding"
                            v-model="medical"
                          ></v-checkbox>

                          <v-checkbox
                            label="27. Residence Type"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>

                           <v-checkbox
                            label="28. Religion"
                            :class="classPadding"
                            v-model="sem"
                          ></v-checkbox>
                          <v-checkbox
                            label="29. Disciplinary Case - Classification"
                            :class="classPadding"
                            v-model="semRecomm"
                          ></v-checkbox>
                          <v-checkbox
                            label="30. Disciplinary Case - Main Article"
                            :class="classPadding"
                            v-model="medical"
                          ></v-checkbox>

                          <v-checkbox
                            label="31. Disciplinary Case - Sub Article"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>

                           <v-checkbox
                            label="32. Disciplinary Case - Specific Type"
                            :class="classPadding"
                            v-model="sem"
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="12" xs="12" sm="4" md="3" class="pa-0 ma-0">
                          <v-checkbox
                            label="33. Disciplinary Case - Action"
                            :class="classPadding"
                            v-model="semRecomm"
                          ></v-checkbox>
                          <v-checkbox
                            label="34. Course/Degree"
                            :class="classPadding"
                            v-model="medical"
                          ></v-checkbox>

                          <v-checkbox
                            label="35. Educational Attainment"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>

                          <v-checkbox
                            label="36. Major"
                            :class="classPadding"
                            v-model="sem"
                          ></v-checkbox>
                          <v-checkbox
                            label="37. Course And Seminar Title"
                            :class="classPadding"
                            v-model="semRecomm"
                          ></v-checkbox>
                          <v-checkbox
                            label="38. Seminar Classification"
                            :class="classPadding"
                            v-model="medical"
                          ></v-checkbox>

                          <v-checkbox
                            label="39. Seminar Classification Signatories"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>

                           <v-checkbox
                            label="40. Seminar Type"
                            :class="classPadding"
                            v-model="sem"
                          ></v-checkbox>
                          <v-checkbox
                            label="41. Accredited Body"
                            :class="classPadding"
                            v-model="semRecomm"
                          ></v-checkbox>
                          <v-checkbox
                            label="42. Seminar Classification"
                            :class="classPadding"
                            v-model="medical"
                          ></v-checkbox>

                          <v-checkbox
                            label="43. Seminar Classification Signatories"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>

                           <v-checkbox
                            label="44. Seminar Type"
                            :class="classPadding"
                            v-model="sem"
                          ></v-checkbox>
                          <v-checkbox
                            label="45. Accredited Body"
                            :class="classPadding"
                            v-model="semRecomm"
                          ></v-checkbox>
                          <v-checkbox
                            label="46. Annual Physical Examination"
                            :class="classPadding"
                            v-model="medical"
                          ></v-checkbox>

                          <v-checkbox
                            label="47. Awards and Commendations"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>

                          <v-checkbox
                            label="48. Signatory Type"
                            :class="classPadding"
                            v-model="medical"
                          ></v-checkbox>
                        </v-col>

                        <v-col cols="12" xs="12" sm="4" md="3" class="pa-0 ma-0">
                          <v-checkbox
                            label="49. Document Submitted"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>

                          <v-checkbox
                            label="50. Duties and Responsibilities"
                            :class="classPadding"
                            v-model="medical"
                          ></v-checkbox>

                          <v-checkbox
                            label="51. Exam Type"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>

                          <v-checkbox
                            label="52. Field of Interest"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>

                          <v-checkbox
                            label="53. Government Exam"
                            :class="classPadding"
                            v-model="medical"
                          ></v-checkbox>

                          <v-checkbox
                            label="54. Government Forms"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>

                          <v-checkbox
                            label="55. Health Insurance"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>

                          <v-checkbox
                            label="56. Job Requirements"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>

                          <v-checkbox
                            label="57. Licenses"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>

                          <v-checkbox
                            label="58. Insurance Claim"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>

                          <v-checkbox
                            label="59. Medical Cases"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>

                          <v-checkbox
                            label="60. Overseas Placement Status"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>

                          <v-checkbox
                            label="61. Benefit"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>

                           <v-checkbox
                            label="62. Medical Reimbursements"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>

                           <v-checkbox
                            label="63. Project File"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>

                           <v-checkbox
                            label="64. Skills"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>

                          <v-checkbox
                            label="64. Online Approval"
                            :class="classPadding"
                            v-model="healthIns"
                          ></v-checkbox>
                        </v-col> -->
                    </v-row>
                </v-card-text>
            </v-card>
            <v-row>
                <v-col cols="12" xs="12" sm="6" md="6">
                    <v-file-input label="Import file"
                                  :class="classPadding"
                                  v-model="file"></v-file-input>
                </v-col>
                <v-col cols="12" xs="12" sm="6" md="4">
                    <v-btn outlined :loading="isUploading" @click.prevent="upload">Upload</v-btn>&nbsp;
                    <v-btn color="success"
                           outlined
                           :loading="isSaving"
                           @click.prevent="save"
                           :disabled="hasError"
                           v-if="userAccess.submit >= 1">Save</v-btn>
                </v-col>
            </v-row>

            <v-card>
                <v-tabs dark show-arrows background-color="primary" v-model="tab">
                    <v-tabs-slider></v-tabs-slider>

                    <v-tab v-for="(item, key) in setupList" :key="key">
                        <span class="caption">{{ item.name }}</span>
                    </v-tab>
                    <v-tabs-items v-model="tab">
                        <!-- <v-tab-item v-for="item in items" :key="item.tab">
                          <v-card flat>
                            <v-card-text>{{ item.content }}</v-card-text>
                          </v-card>
                        </v-tab-item>-->
                        <v-tab-item>
                            <v-card flat>
                                <payroll-location :items="payLocList" :properties="properties"></payroll-location>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <timekeep :items="tkList" :properties="properties"></timekeep>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <pagibig :items="pagibigList" :properties="properties"></pagibig>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <movement-type-details :items="mtdList" :properties="properties"></movement-type-details>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <earnings :items="earnList" :properties="properties"></earnings>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <deductions :items="deducList" :properties="properties"></deductions>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <areas :items="areaList" :properties="properties"></areas>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <pay-house :items="phList" :properties="properties"></pay-house>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <branch :items="braList" :properties="properties"></branch>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <department :items="depList" :properties="properties"></department>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <division :items="divList" :properties="properties"></division>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <group :items="groupList" :properties="properties"></group>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <location :items="locList" :properties="properties"></location>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <section-com :items="secList" :properties="properties"></section-com>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <unit :items="unitList" :properties="properties"></unit>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <designation :items="desList" :properties="properties"></designation>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <job-level :items="jlList" :properties="properties"></job-level>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <emp-status :items="empStatList" :properties="properties"></emp-status>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <emp-category :items="empCatList" :properties="properties"></emp-category>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <emp-class :items="empClassList" :properties="properties"></emp-class>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <desig-duties-res :items="desDuResList" :properties="properties"></desig-duties-res>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <rank :items="rankList" :properties="properties"></rank>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <grade :items="gradeList" :properties="properties"></grade>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <step :items="stepList" :properties="properties"></step>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <specialization :items="specList" :properties="properties"></specialization>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <province :items="provinceList" :properties="properties"></province>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <residence-type :items="resTypeList" :properties="properties"></residence-type>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <religion :items="relList" :properties="properties"></religion>
                            </v-card>
                        </v-tab-item>

                        <!-- Disc Case -->
                        <v-tab-item>
                            <v-card flat>
                                <disc-case-class :items="discCaseClassList" :properties="properties"></disc-case-class>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <disc-case-main-art :items="discCaseMainArtList" :properties="properties"></disc-case-main-art>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <disc-case-sub-art :items="discCaseSubArtList" :properties="properties"></disc-case-sub-art>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <disc-case-spec-type :items="discCaseSpecTypeList" :properties="properties"></disc-case-spec-type>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <disc-case-action :items="discCaseActionList" :properties="properties"></disc-case-action>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <course :items="courseList" :properties="properties"></course>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <educ-attainment :items="eduAttList" :properties="properties"></educ-attainment>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <major :items="majorList" :properties="properties"></major>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <school :items="schoolList" :properties="properties"></school>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <seminar-course :items="semCourseList" :properties="properties"></seminar-course>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <seminar-class :items="semClassList" :properties="properties"></seminar-class>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <seminar-class-signatory :items="semClassSigList" :properties="properties"></seminar-class-signatory>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <seminar-type :items="semTypeList" :properties="properties"></seminar-type>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <accredited-body :items="accreBodyList" :properties="properties"></accredited-body>
                            </v-card>
                        </v-tab-item>

                        <!-- Others -->
                        <v-tab-item>
                            <v-card flat>
                                <annual-physical-exam :items="apeList" :properties="properties"></annual-physical-exam>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <awards-commendation :items="awardCommList" :properties="properties"></awards-commendation>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <signatory-type :items="sigTypeList" :properties="properties"></signatory-type>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <document-submitted :items="docSubList" :properties="properties"></document-submitted>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <duties-responsibities :items="dutResList" :properties="properties"></duties-responsibities>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <exam-type :items="examTypeList" :properties="properties"></exam-type>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <field-of-interest :items="foiList" :properties="properties"></field-of-interest>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <government-exam :items="govExamList" :properties="properties"></government-exam>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <government-forms :items="govFormList" :properties="properties"></government-forms>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <health-insurance :items="healthInsList" :properties="properties"></health-insurance>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <job-requirement :items="jobReqList" :properties="properties"></job-requirement>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <licenses :items="licList" :properties="properties"></licenses>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <insurance-claim :items="insClaimList" :properties="properties"></insurance-claim>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <medical-cases :items="medCaseList" :properties="properties"></medical-cases>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <overseas-placement :items="overseasList" :properties="properties"></overseas-placement>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <benefits :items="benefitList" :properties="properties"></benefits>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <medical-reimbursement :items="medReimList" :properties="properties"></medical-reimbursement>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <project-file :items="projFileList" :properties="properties"></project-file>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <project-details :items="projDList" :properties="properties"></project-details>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <skills :items="skillList" :properties="properties"></skills>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat>
                                <online-approval :items="onlineAppList" :properties="properties"></online-approval>
                            </v-card>
                        </v-tab-item>

                        <!--RLV:06Jul2022-->
                        <v-tab-item>
                            <v-card flat>
                                <eSGrouping :items="esgroupingList" :properties="properties"></eSGrouping>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <v-card flat>
                                <holiCalendar :items="holiCalendarList" :properties="properties"></holiCalendar>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <v-card flat>
                                <pSGrouping :items="psgroupingList" :properties="properties"></pSGrouping>
                            </v-card>
                        </v-tab-item>

                    </v-tabs-items>
                </v-tabs>
            </v-card>
            <span class="caption" :class="classPadding">
                Click [
                <a @click="downloadFile">here</a>] to download the format.
            </span>
        </v-container>
    </div>
</template>
<script>
    import { isNullOrUndefined } from "../../../validation/validation.js";
    import userAccessMixin from "../../../mixins/userAccessMixin";
    import { setupList } from "../../../constants/importSetupData"
    import isEmpty from "lodash/isEmpty"
    const PayrollLocation = () => import("./PayrollLocation.vue");
    const Timekeep = () => import("./Timekeep.vue");
    const Pagibig = () => import("./Pagibig.vue");
    const MovementTypeDetails = () => import("./MovementTypeDetails.vue");
    const Earnings = () => import("./Earnings.vue");
    const Deductions = () => import("./Deductions.vue");
    const Area = () => import("./Area.vue");
    const PayHouse = () => import("./PayHouse.vue");
    const Branch = () => import("./Branch.vue");
    const Department = () => import("./Department.vue");
    const Division = () => import("./Division.vue");
    const Group = () => import("./Group.vue");
    const Location = () => import("./Location.vue");
    const Section = () => import("./Section.vue");
    const Unit = () => import("./Unit.vue");
    const Designation = () => import("./Designation.vue");
    const JobLevel = () => import("./JobLevel.vue");
    const EmpStatus = () => import("./EmpStatus.vue");
    const EmpCategory = () => import("./EmpCategory.vue");
    const EmpClass = () => import("./EmpClass.vue");
    const DesigDutiesRes = () => import("./DesigDutiesRes.vue");
    const Rank = () => import("./Rank.vue");
    const Grade = () => import("./Grade.vue");
    const Step = () => import("./Step.vue");
    const Specialization = () => import("./Specialization.vue");
    const Province = () => import("./Province.vue");
    const ResidenceType = () => import("./ResidenceType.vue");
    const Religion = () => import("./Religion.vue");
    const DiscCaseAction = () => import("./DiscCaseAction.vue");
    const DiscCaseClass = () => import("./DiscCaseClass.vue");
    const DiscCaseMainArt = () => import("./DiscCaseMainArt.vue");
    const DiscCaseSpecType = () => import("./DiscCaseSpecType.vue");
    const DiscCaseSubArt = () => import("./DiscCaseSubArt.vue");
    const Course = () => import("./Course.vue");
    const EducAttainment = () => import("./EducAttainment.vue");
    const Major = () => import("./Major.vue");
    const School = () => import("./School.vue");
    const SeminarType = () => import("./SeminarType.vue");
    const SeminarClass = () => import("./SeminarClass.vue");
    const SeminarClassSignatory = () => import("./SeminarClassSignatory.vue");
    const SeminarCourse = () => import("./SeminarCourse.vue");
    const AccreditedBody = () => import("./AccreditedBody.vue");
    // Others
    const AnnualPhysicalExam = () => import("./AnnualPhysicalExam.vue");
    const AwardsCommendation = () => import("./AwardsCommendation.vue");
    const SignatoryType = () => import("./SignatoryType.vue");
    const DocumentSubmitted = () => import("./DocumentSubmitted.vue");
    const DutiesResponsibities = () => import("./DutiesResponsibities.vue");
    const ExamType = () => import("./ExamType.vue");
    const FieldOfInterest = () => import("./FieldOfInterest.vue");
    const GovernmentExam = () => import("./GovernmentExam.vue");
    const GovernmentForms = () => import("./GovernmentForms.vue");
    const HealthInsurance = () => import("./HealthInsurance.vue");
    const JobRequirement = () => import("./JobRequirement.vue");
    const Licenses = () => import("./Licenses.vue");
    const InsuranceClaim = () => import("./InsuranceClaim.vue");
    const MedicalCases = () => import("./MedicalCases.vue");
    const Benefits = () => import("./Benefits.vue");
    const OverseasPlacement = () => import("./OverseasPlacement.vue");
    const MedicalReimbursement = () => import("./MedicalReimbursement.vue");
    const ProjectFile = () => import("./ProjectFile.vue");
    const ProjectDetails = () => import("./ProjectDetails.vue");
    const Skills = () => import("./Skills.vue");
    const OnlineApproval = () => import("./OnlineApproval.vue");

    /*RLV:06Jul2022*/
    const ESGrouping = () => import("./ESGrouping.vue");
    const HoliCalendar = () => import("./HoliCalendar.vue");
    const PSGrouping = () => import("./PSGrouping.vue");

    const API_ENDPOINT = "/api/importSetupData";
    export default {
        metaInfo: {
            title: "Import Setup Data Masterfile",
            titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
        },
        mixins: [userAccessMixin],
        components: {
            PayrollLocation,
            Timekeep,
            Pagibig,
            MovementTypeDetails,
            Earnings,
            Deductions,
            Areas: Area,
            PayHouse,
            Branch,
            Department,
            Division,
            Group,
            Location,
            SectionCom: Section,
            Unit,
            Designation,
            JobLevel,
            EmpStatus,
            EmpCategory,
            EmpClass,
            DesigDutiesRes,
            Rank,
            Grade,
            Step,
            Specialization,
            Province,
            ResidenceType,
            Religion,
            DiscCaseClass,
            DiscCaseMainArt,
            DiscCaseSubArt,
            DiscCaseSpecType,
            DiscCaseAction,
            Course,
            EducAttainment,
            Major,
            School,
            SeminarType,
            SeminarClass,
            SeminarClassSignatory,
            SeminarCourse,
            AccreditedBody,
            AnnualPhysicalExam,
            AwardsCommendation,
            SignatoryType,
            DocumentSubmitted,
            DutiesResponsibities,
            ExamType,
            FieldOfInterest,
            GovernmentExam,
            GovernmentForms,
            HealthInsurance,
            JobRequirement,
            Licenses,
            InsuranceClaim,
            MedicalCases,
            Benefits,
            OverseasPlacement,
            MedicalReimbursement,
            ProjectFile,
            ProjectDetails,
            Skills,
            OnlineApproval,

            /*RLV:06Jul2022*/
            ESGrouping,
            HoliCalendar,
            PSGrouping
        },
        data: () => ({
            title: "Import Setup Data",
            classPadding: "my-0 py-0",
            isUploading: false,
            isSaving: false,
            tab: null,
            selectedSetup: [],
            file: null,
            errors: [],
            showError: false,
            properties: [],
            setupList,
            checkAll: false,
            payLocList: [],
            tkList: [],
            pagibigList: [],
            mtdList: [],
            earnList: [],
            deducList: [],
            areaList: [],
            phList: [],
            braList: [],
            depList: [],
            divList: [],
            groupList: [],
            locList: [],
            secList: [],
            unitList: [],
            desList: [],
            jlList: [],
            empStatList: [],
            empCatList: [],
            empClassList: [],
            desDuResList: [],
            rankList: [],
            gradeList: [],
            stepList: [],
            specList: [],
            provinceList: [],
            resTypeList: [],
            relList: [],
            discCaseClassList: [],
            discCaseMainArtList: [],
            discCaseSubArtList: [],
            discCaseSpecTypeList: [],
            discCaseActionList: [],
            courseList: [],
            eduAttList: [],
            majorList: [],
            schoolList: [],
            semTypeList: [],
            semClassList: [],
            semClassSigList: [],
            semCourseList: [],
            accreBodyList: [],
            apeList: [],
            awardCommList: [],
            sigTypeList: [],
            docSubList: [],
            dutResList: [],
            examTypeList: [],
            foiList: [],
            govExamList: [],
            govFormList: [],
            healthInsList: [],
            jobReqList: [],
            licList: [],
            insClaimList: [],
            medCaseList: [],
            benefitList: [],
            overseasList: [],
            medReimList: [],
            projFileList: [],
            projDList: [],
            skillList: [],
            onlineAppList: [],

            /*RLV: 06Jul2022*/
            esgroupingList: [],
            holiCalendarList: [],
            psgroupingList: []
        }),
        computed: {
            hasError() {
                if (this.errors.length > 0) {
                    return true;
                } else {
                    if (
                        !isNullOrUndefined(this.file) && !isEmpty(this.uploadedItems)
                    ) {
                        return false;
                    } else {
                        return true;
                    }
                }
            }

            // basicAlloEarn() {
            //   if (this.file !== null && this.errors.length > 0) {
            //   }
            // },
        },
        methods: {
            upload() {
                this.isUploading = true;
                var formData = new FormData();
                var data = {
                    SelectedSetup: this.selectedSetup
                };
                formData.append("json", JSON.stringify(data));
                formData.append("file", this.file);

                this.$axios({
                    method: "POST",
                    url: `${API_ENDPOINT}/upload`,
                    data: formData,
                    config: {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                })
                    .then(({ data }) => {
                        if (data.errors.length > 0) {
                            this.errors = data.errors;
                            this.properties = data.properties;
                        } else {
                            this.errors = [];
                            this.properties = [];
                        }
                        console.log(data)
                        this.uploadedItems = data;

                        this.payLocList = data.payrollLocations;
                        this.tkList = data.timekeep;
                        this.pagibigList = data.pagibig;
                        this.mtdList = data.mtd;
                        this.earnList = data.earnings;
                        this.deducList = data.deductions;
                        this.areaList = data.areas;
                        this.phList = data.payHouse;
                        this.braList = data.branch;
                        this.depList = data.department;
                        this.divList = data.division;
                        this.groupList = data.group;
                        this.locList = data.location;
                        this.secList = data.section;
                        this.unitList = data.unit;
                        this.desList = data.designation;
                        this.jlList = data.jobLevel;
                        this.empStatList = data.empStatus;
                        this.empCatList = data.empCategory;
                        this.empClassList = data.empClassification;
                        this.desDuResList = data.desigDutiesRes;
                        this.rankList = data.rank;
                        this.gradeList = data.grade;
                        this.stepList = data.step;
                        this.specList = data.specialization;
                        this.provinceList = data.province;
                        this.resTypeList = data.residenceType;
                        this.relList = data.religion;
                        this.discCaseClassList = data.discCaseClass;
                        this.discCaseMainArtList = data.discCaseMainArt;
                        this.discCaseSubArtList = data.discCaseSubArt;
                        this.discCaseSpecTypeList = data.discCaseSpecType;
                        this.discCaseActionList = data.discCaseAction;
                        this.courseList = data.course;
                        this.eduAttList = data.educAttainment;
                        this.majorList = data.major;
                        this.schoolList = data.school;
                        this.semTypeList = data.seminarType;
                        this.semClassList = data.seminarClass;
                        this.semClassSigList = data.seminarClassSign;
                        this.semCourseList = data.seminarCourse;
                        this.accreBodyList = data.accreditedBody;
                        this.apeList = data.annualPhysicalExam;
                        this.awardCommList = data.awardCommendation;
                        this.sigTypeList = data.signatoryType;
                        this.docSubList = data.documentSubmitted;
                        this.dutResList = data.dutiesResponsibilities;
                        this.examTypeList = data.examType;
                        this.foiList = data.fieldOfInterest;
                        this.govExamList = data.governmentExam;
                        this.govFormList = data.governmentForm;
                        this.healthInsList = data.healthInsurance;
                        this.jobReqList = data.jobRequirement;
                        this.licList = data.license;
                        this.insClaimList = data.insuranceClaim;
                        this.medCaseList = data.medicalCase;
                        this.benefitList = data.benefits;
                        this.overseasList = data.overseasPlacement;
                        this.medReimList = data.medicalReimbursements;
                        this.projFileList = data.projectFile;
                        this.projDList = data.projectDetails;
                        this.skillList = data.skills;
                        this.onlineAppList = data.onlineApproval;

                        /*RLV: 06Jul2022*/
                        this.esgroupingList = data.esGrouping;
                        this.holiCalendarList = data.holiCalendar;
                        this.psgroupingList = data.psGrouping;
                    })
                    .catch(({ response }) => {
                        this.$toast.error(response.data.message);
                    })
                    .finally(() => {
                        this.isUploading = false;
                    });
            },
            save() {
                this.isSaving = true;
                this.uploadedItems.selectedSetup = this.selectedSetup;
                this.$axios
                    .post(`${API_ENDPOINT}/save`, this.uploadedItems)
                    .then(() => {
                        this.$toast.success("Record Successfully Uploaded");
                        this.reset();
                    })
                    .catch(({ response }) => {
                        this.$toast.error(response.data.message);
                    })
                    .finally(() => {
                        this.isSaving = false;
                    });
            },
            reset() {
                this.checkAll = false
                this.selectedSetup = []
                this.payLocList = [];
                this.tkList = [];
                this.pagibigList = []
                this.mtdList = [];
                this.earnList = [];
                this.deducList = [];
                this.desList = [];
                this.jlList = [];
                this.empStatList = [];
                this.empCatList = [];
                this.empClassList = [];
                this.desDuResList = [];
                this.rankList = [];
                this.gradeList = [];
                this.stepList = [];
                this.specList = [];
                this.provinceList = [];
                this.resTypeList = [];
                this.relList = [];
                this.discCaseClassList = [];
                this.discCaseMainArtList = [];
                this.discCaseSubArtList = [];
                this.discCaseSpecTypeList = [];
                this.discCaseActionList = [];
                this.courseList = [];
                this.eduAttList = [];
                this.majorList = [];
                this.schoolList = [];
                this.semTypeList = [];
                this.semClassList = [];
                this.semClassSigList = [];
                this.semCourseList = [];
                this.accreBodyList = [];
                this.apeList = [];
                this.awardCommList = [];
                this.sigTypeList = [];
                this.docSubList = [];
                this.dutResList = [];
                this.examTypeList = [];
                this.foiList = [];
                this.govExamList = [];
                this.govFormList = [];
                this.healthInsList = [];
                this.jobReqList = [];
                this.licList = [];
                this.insClaimList = [];
                this.medCaseList = [];
                this.benefitList = [];
                this.overseasList = [];
                this.medReimList = [];
                this.projFileList = [];
                this.projDList = [];
                this.skillList = [];
                this.onlineAppList = [];

                /*RLV: 06Jul2022*/
                this.esgroupingList = [];
                this.holiCalendarList = [];
                this.psgroupingList = [];

                this.file = null;
            },
            downloadFile() {
                var subPath = process.env.VUE_APP_PATH;

                window.open(
                    `${subPath.slice(0, -1)}/Files/downloads/Setup Format.xlsx`
                );

                // var nameOfTheCsv = "Setup Format.xlsx";
                //     this.$axios
                //       .get(`/Files/downloads/Setup Format.xlsx`, {
                //         responseType: "blob",
                //       })
                //       .then((response) => {
                //         const downloadUrl = window.URL.createObjectURL(
                //           new Blob([response.data])
                //         );
                //         const link = document.createElement("a");
                //         link.href = downloadUrl;
                //         link.setAttribute("download", nameOfTheCsv);
                //         document.body.appendChild(link);
                //         link.click();
                //         link.remove();
                //       })
                //       .catch((err) => console.log(err));
            }
        },
        watch: {
            checkAll(val) {
                if (val) {
                    var items = this.setupList.map(x => {
                        return x.value;
                    })

                    this.selectedSetup = items; //console.log(items);
                } else {
                    this.selectedSetup = []
                }
            },
            errors(val) {
                if (val.length > 0) this.showError = true;
                else this.showError = false;
            }
        },
        created() {
            this.getUserAccessRights("ImpSetup");
        }
    };
</script>